import {getItemById, getItemByKey} from "./items";

const Airdrops = [
    {
        slug: 'sps-75m-1',
        key: 'sps-75m-1',
        contract_address: "0xced83eDBb93CBaB513a46dc46c707B3856aA144f",
        name: "SPS GROVE #1/8",
        description: "SPS GROVE airdrop #1/8. Uses tier system per NFT.\nSnapshot taken on July 24th 2024.",
        image: "/airdrops/sps-75m-1.png",
        items: [

        ],
        isToken: true
    },
    {
        slug: 'sps',
        key: 'sps',
        contract_address: "0x02B52e4515A5131B4B08790Ebb50D3d56fFDF85F",
        name: "SPS Starter Pack",
        description: "Claim this GroveWars starter pack for owning a SPS Pine. Snapshot taken on July 24th 2024.",
        image: "/airdrops/sps@2x.png",
        items: [
            getItemByKey('character_secret_society_pineya'),
            getItemByKey('weapon_secret_society_t_fury')
        ]
    },
    {
        slug: 'ss-sps',
        key: 'ss-sps',
        contract_address: "0x694EeD4f2121937093Be70d7Bbe004b699211F23",
        name: "Silver Skull for SPS",
        description: "Claim this Silver Skull back swag for owning a SPS Pine. Snapshot taken on July 24th 2024.",
        image: "/airdrops/ss-sps@2x.png",
        items: [
            getItemByKey('back_swag_silver_pine_skull')
        ]
    },
    // {
    //     slug: 'elite-booster',
    //     key: 'elite-booster',
    //     contract_address: "0x",
    //     name: "ELite Booster Pack",
    //     description: "All Elite Edge Booster participants can claim this booster pack",
    //     image: "/airdrops/edge-node-booster.png",
    //     items: [
    //         getItemByKey('character_edge_node_pineya'),
    //         getItemByKey('weapon_edge_node_t_fury'),
    //         getItemByKey('back_swag_edge_node_booster_pack')
    //     ]
    // }
];

export default Airdrops;

export const getAirdropByKey = (key) => {
    return Airdrops.find(a => a.key === key);
}

export const getAirdropBySlug = (slug) => {
    return Airdrops.find(a => a.slug === slug);
}